/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Status_Athlete_PendingInputs */

const fr_session_status_athlete_pending = /** @type {(inputs: Session_Status_Athlete_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A effectuer`)
};

/**

* @param {Session_Status_Athlete_PendingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_status_athlete_pending = /** @type {((inputs?: Session_Status_Athlete_PendingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Status_Athlete_PendingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_status_athlete_pending(inputs)
});